export enum EErrorCode {
  InvalidPayload = 'INVALID_PAYLOAD',
  ShiftInvalidDateRange = 'SHIFT_INVALID_DATE_RANGE',
  ShiftShortNameTooLong = 'SHIFT_SHORT_NAME_TOO_LONG',
  ShiftVersionNoBoundary = 'SHIFT_VERSION_NO_BOUNDARY',
  ShiftInvalidCapacity = 'SHIFT_INVALID_CAPACITY',
  ShiftInvalidPause = 'SHIFT_INVALID_PAUSE',
  ShiftInvalidEligibleUsers = 'SHIFT_INVALID_ELIGIBLE_USERS',
  ShiftReorderStale = 'SHIFT_REORDER_STALE',
  RuleGroupInvalidUsers = 'RULE_GROUP_INVALID_USERS',
  RuleGroupInvalidRules = 'RULE_GROUP_INVALID_RULES',
  ShiftAssignmentNoActiveConfig = 'SHIFT_ASSIGNMENT_NO_ACTIVE_CONFIG',
  ShiftAssignmentConflictingConfig = 'SHIFT_ASSIGNMENT_CONFLICTING_CONFIG',
  ShiftAssignmentUserBusy = 'SHIFT_ASSIGNMENT_USER_BUSY',
  ShiftAssignmentUserAbsent = 'SHIFT_ASSIGNMENT_USER_ABSENT',
  ShiftAssignmentShiftNotActive = 'SHIFT_ASSIGNMENT_SHIFT_NOT_ACTIVE',
  ShiftAssignmentInvalidTimeRange = 'SHIFT_ASSIGNMENT_INVALID_TIME_RANGE',
  ShiftAssignmentInvalidPause = 'SHIFT_ASSIGNMENT_INVALID_PAUSE',
  ShiftAssignmentGenerationInProgress = 'SHIFT_ASSIGNMENT_GENERATION_IN_PROGRESS',
  VacationNotFound = 'VACATION_NOT_FOUND',
  VacationPastStart = 'VACATION_PAST_START',
  QualificationNotFound = 'QUALIFICATION_NOT_FOUND',
  QualificationNameTaken = 'QUALIFICATION_NAME_TAKEN',
  QualificationCategoryTaken = 'QUALIFICATION_CATEGORY_TAKEN',
  QualificationRecordNotFound = 'QUALIFICATION_RECORD_NOT_FOUND',
  QualificationRecordYearTaken = 'QUALIFICATION_RECORD_YEAR_TAKEN',
}
